import React, { Component } from 'react';
import byteArray from '../utils/byteArray';
import './Utils.css';

export default class Utils extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="Utils">
        <div className="Utils-header">
          <h5>32 Cryptographically Random Bytes for Remix</h5>
          <p className="wrap">{byteArray.getNBytes(32)}</p>
        </div>
      </div>
    )
  }
}
